export function otpExpiryCalculator(expiry: string | number | undefined | null): Date | null {
  if (!expiry) {
    return null;
  }

  return new Date(Number(expiry.toString()));
}
